import type { PriceRange } from '@wineryxplorer/shared';

interface PriceRangeDisplayProps {
  value?: PriceRange;
  className?: string;
}

const PRICE_RANGE_SYMBOLS = {
  1: '$',
  2: '$$',
  3: '$$$',
  4: '$$$$',
  5: '$$$$$',
} as const;

const PRICE_RANGE_LABELS = {
  1: 'Budget Friendly',
  2: 'Moderate',
  3: 'Mid-Range',
  4: 'Upscale',
  5: 'Luxury',
} as const;

export const PriceRangeDisplay = ({ value, className = '' }: PriceRangeDisplayProps) => {
  if (!value) {
    return null;
  }

  const symbols = PRICE_RANGE_SYMBOLS[value];
  const label = PRICE_RANGE_LABELS[value];

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <span
        className="text-gray-900 font-semibold text-lg sm:text-xl tracking-wider"
        title={label}
        aria-label={`Price range: ${label}`}
      >
        {symbols}
      </span>
      <span className="text-gray-600 text-sm sm:text-base">{label}</span>
    </div>
  );
};